import { getLogoWhite } from "@/utils/assets";
import { CONTACT, content } from "@/i18n/content";
import { useLang } from "@/i18n/language";

export function SiteFooter() {
  const logo = getLogoWhite();
  const { lang } = useLang();
  const t = content[lang];

  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-5 py-12 md:flex-row md:items-start md:justify-between md:px-8">
        <div className="max-w-sm">
          <img src={logo.url} alt="Share The Med" className="h-10 w-auto" />
          <p className="mt-4 font-serif text-lg text-muted-foreground">{t.hero.tagline}</p>
        </div>

        <div className="grid gap-6 text-sm sm:grid-cols-2">
          <div className="space-y-2">
            <p className="eyebrow text-primary">{t.contact.whatsapp}</p>
            <a href={CONTACT.whatsappHref} className="block text-muted-foreground hover:text-foreground">
              {CONTACT.whatsapp}
            </a>
            <p className="eyebrow pt-3 text-primary">{t.contact.email}</p>
            <a href={`mailto:${CONTACT.email}`} className="block text-muted-foreground hover:text-foreground">
              {CONTACT.email}
            </a>
          </div>
          <div className="space-y-2">
            <p className="eyebrow text-primary">{t.contact.instagram}</p>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              className="block text-muted-foreground hover:text-foreground"
            >
              {CONTACT.instagramHandle}
            </a>
            <p className="eyebrow pt-3 text-primary">LinkedIn / Facebook</p>
            <p className="text-muted-foreground">{CONTACT.linkedin}</p>
          </div>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-5 py-6 text-xs text-muted-foreground md:flex-row md:items-center md:justify-between md:px-8">
          <p>© {new Date().getFullYear()} Share The Med (STM). {t.footer.rights}</p>
          <p className="max-w-md">{t.footer.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}
